/* @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import Colors from "util/colors";
import { useTranslation } from "react-i18next";
import { ReactComponent as Circle } from "features/wc/assets/circle.svg";
import { ReactComponent as Cross } from "features/wc/assets/cross.svg";

const colors = Colors.get();

const Wrapper = styled("div")({
  height: "65px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "18px",
  margin: "5px 0px 5px 0px",
  backgroundColor: colors.white,
  borderRadius: "6px",
});
const Label = styled("div")({
  fontSize: "16px",
  fontWeight: 300,
  lineHeight: "20px",
});
const Counter = styled("div")({
  display: "flex",
  alignItems: "center",
});
const Info = styled("div")({
  display: "flex",
  alignItems: "center",
});
const OpenLabel = styled("div")({
  margin: "0px 5px 0px 2px",
  fontWeight: 600,
  fontSize: "16px",
  textAlign: "center",
  color: colors.open,
  paddingTop: "2px"
});
const CloseLabel = styled("div")({
  margin: "0px 5px 0px 2px",
  fontWeight: 600,
  fontSize: "16px",
  textAlign: "center",
  color: colors.close,
  paddingTop: "2px"
});
const CountDetail = styled("div")({
  width: "50px",
  textAlign: "center",
  marginLeft: "20px"
});
const CountLabel = styled("div")({
  fontSize: "12px",
  fontWeight: 300,
  lineHeight: "12px"
});
const Count = styled("div")({
  display: "flex",
  justifyContent: "center",
  lineHeight: "16px",
  marginTop: "8px"
});
const BoothCount = styled("div")({
  marginTop: "1px",
  fontSize: "15px",
  fontWeight: 300,
});
const OpenBoothCount = styled("div")({
  marginRight: "2px",
  fontWeight: 600,
  fontSize: "22px",
});

/**
 * プロパティ定義
 */
type Props = {
  /** トイレ設置場所 */
  locationName: string;
  /** トイレ個室数 */
  boothCount: number;
  /** 空きトイレ個室数 */
  openBoothCount: number;
};

/**
 * リストアイテム（カウンター）
 * @param param コンポーネントのProps
 */
export default function CrowdLabel({
  locationName,
  boothCount,
  openBoothCount,
}: Props) {
  const { t } = useTranslation("トイレ可視化");
  return (
    <Wrapper>
      <Label>{locationName}</Label>
      <Counter>
        {openBoothCount === 0 ? 
          <Info>
            <Cross />
            <CloseLabel>{t("空きなし")}</CloseLabel> 
          </Info>
         : 
          <Info>
            <Circle />
            <OpenLabel>{t("空きあり")}</OpenLabel> 
          </Info>
        }
        <CountDetail>
          <CountLabel>{t("空き個室")}</CountLabel>
          <Count>
            <OpenBoothCount css={{ color: openBoothCount === 0 ? colors.close : colors.open }}>
              {openBoothCount}
            </OpenBoothCount>
            <BoothCount>/{boothCount}</BoothCount>
          </Count>
        </CountDetail>
      </Counter>
    </Wrapper>
  );
}
